import React from 'react'
import { CloseCircle, Edit2 } from 'iconsax-react'
import { useAppDispatch } from '@SonarCX/hooks/redux'
import { useTheme } from '@mui/material'

import AreYouSureModal from '@SonarCX/components/molecules/ChatModals/AreYouSureModal'

import { AddSuccessAlert } from '@SonarCX/slices/alert'
import { removeTeam } from '@SonarCX/slices/teamsSlice'
import useStyles from './styles'

interface EditDeleteProps {
  open: (data: APITeam) => () => void
  data: APITeam
}

const EditDelete: React.FC<EditDeleteProps> = ({ open, data }) => {
  const dispatch = useAppDispatch()
  const theme = useTheme()

  const [deleteCheck, setDeleteCheck] = React.useState(false)

  const classes = useStyles()

  return (
    <div className={classes.root}>
      <Edit2
        size={theme.size.base}
        className={classes.icon}
        onClick={open(data)}
      />

      <CloseCircle
        size={theme.size.base}
        className={classes.icon}
        onClick={() => {
          setDeleteCheck(true)
        }}
      />

      {deleteCheck && (
        <AreYouSureModal
          open={deleteCheck}
          title=''
          hideCancel={false}
          onAccept={async () => {
            await dispatch(removeTeam(data?.id))
            dispatch(AddSuccessAlert('Team deleted'))
            setDeleteCheck(false)
          }}
          onClose={() => setDeleteCheck(false)}
          reason={'Are you sure you want to delete this team'}
          subtext={'Everything using this team will be affected.'}
        />
      )}
    </div>
  )
}

export default EditDelete
